// src/skills/glyphbinding/index.js
// Glyphbinding skill registration

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderGlyphbindingUI, updateGlyphbindingUI, initGlyphbindingUI } from './glyphbindingUI.js';
import { glyphbindingSkill } from './glyphbinding.js';
import { gameState } from '../../game/gameState.js';
import { SKILLS } from '../../game/constants.js';
import { ESSENCE_NODES, GLYPH_RECIPES } from './glyphbindingData.js';

skillRegistry.register('glyphbinding', {
    id: 'glyphbinding',
    name: 'Glyphbinding',
    icon: '✦',
    iconImage: 'assets/icons/skill_icons/glyphbinding.png',
    tabs: [
        { id: 'ichor', name: 'Ichor', default: true },
        { id: 'glyphs', name: 'Glyphs' }
    ],
    render: (params) => renderGlyphbindingUI(params),
    update: () => updateGlyphbindingUI(),
    init: () => initGlyphbindingUI(),
    cleanup: () => {
        // Clear any glyphbinding action when leaving
        const action = gameState.getCurrentAction();
        if (action?.type === SKILLS.GLYPHBINDING) {
            // Keep action running for idle gameplay
        }
    },
    onActionComplete: (action) => {
        glyphbindingSkill.handleActionComplete(action);
    },
    getNodeById: (nodeId) => {
        // Check essence nodes
        const node = Object.values(ESSENCE_NODES).find(n => n.id === nodeId);
        if (node) return node;
        // Check glyph recipes
        return Object.values(GLYPH_RECIPES).find(r => r.id === nodeId) || null;
    }
});
